import moment from 'moment';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';

export default function decorateurRectangleNumeriqueChildLc(result, cmd, context) {
  result.line = 0;
  result.key = moment(cmd.dateDebut).format('YYYYMMDD');
  result.label = cmd.annonceur;
  result.fill = niveauDispo.COULEUR_DISPO_INDISPONIBLE_LCNUMERIQUE;

  if (cmd.pourcentageOccupation < 100) {
    // c'est du partiel
    if (cmd.dateDebut > context.endLine1) {
      result.line = 1;
      context.endLine1 = cmd.dateFin;
    } else if (cmd.dateDebut > context.endLine2) {
      result.line = 2;
      context.endLine2 = cmd.dateFin;
    } else {
      result.line = 3; // non affiché
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/decorateur/decorateurRectangleNumeriqueChildLc.js